import { useEffect } from "react";

export default function Loading() {
  useEffect(() => {
    const inputs = Array.from(document.querySelectorAll("input"));

    inputs.forEach((input) => {
      if (input) input.disabled = true;
    });

    return () => {
      inputs.forEach((input) => {
        if (input) {
          input.disabled = false;
        }
      });
    };
  }, []);

  return (
    <section id="loading-comp">
      <img
        src={process.env.PUBLIC_URL + "/Assets/logo/loading.gif"}
        alt="line"
      />
    </section>
  );
}
